import { projectStatusEnum } from "../constants/projectStatusEnum";
const projectStatusOptions = [
  { value: projectStatusEnum.CREATED, label: "Active" },
  { value: projectStatusEnum.COMPLETED, label: "Completed" },
  { value: projectStatusEnum.ONHOLD, label: "On Hold" },
];
export default projectStatusOptions;
